export function Badge({ children }: { children: React.ReactNode }) {
  return (
    <span
      style={{
        display: 'inline-block',
        fontSize: 12,
        padding: '2px 8px',
        borderRadius: 'var(--radius-sm)',
        border: '1px solid var(--border-strong)',
        color: 'var(--text-secondary)',
        background: 'var(--surface-raised)',
      }}
    >
      {children}
    </span>
  )
}
